// extracted by mini-css-extract-plugin
export var icon = "_5h-1";
export var subtext = "_5h-0";